import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { MessageHelper } from '../../providers/helpers/messages';
import { ServiceProvider } from '../../providers/service/service';

@IonicPage()
@Component({
  selector: 'page-cupons',
  templateUrl: 'cupons.html',
})
export class CuponsPage {

  formModal: any = {
    id: null,
    type: "%",
    valor: "",
    codigo: ""
  }

  form: any = {
    status: "",
    type: "",
    page: 1,
    date_start: "",
    date_end: "",
    forpage: 10
  }

  resultData: any = null;
  urlSearch = "/cupons";

  public targetModal : string = "modal-new-cupom";

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private msgHelper: MessageHelper, private service : ServiceProvider,
    private alertCtrl : AlertController) {
  }

  ionViewWillEnter()
  {
    this.search();
  }


  /**
   * Abre o modal de novo cupom
   */
  public new()
  {
    this.formModal = {
      id: null,
      type: "%",
      valor: null,
      codigo: ""
    };
    document.getElementById(this.targetModal).classList.add("show");
  }

  /**
   * Abre modal com os dados do cupom
   * @param obj any
   */
  public update(obj : any)
  {
    this.formModal.id = obj.id;
    this.formModal.codigo = obj.codigo;
    this.formModal.valor = this.transformValor(obj.valor,false);
    this.formModal.type = obj.type;
    document.getElementById(this.targetModal).classList.add("show");
  }

  /**
   * Bloquear o objeto
   * @param obj any
   */
   public block(obj: any) {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja bloquear o cupom?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({ codigo: obj.codigo }, this.urlSearch +  "/block", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * Remove o cupom do sistema
   * @param obj any
   */
   public delete(obj: any) {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja mesmo remover o cupom?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({ codigo: obj.codigo }, this.urlSearch + "/delete", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * Ativar o cupom
   * @param obj any
   */
  public active(obj: any) {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja ativar o cupom?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({ codigo: obj.codigo }, this.urlSearch + "/active", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * Salva o cupom
   */
  public save()
  {
    if (this.formModal.codigo == "" || this.formModal.codigo == null){
      return this.msgHelper.showToast("Você precisa informar o código do cupom","bottom",2000);
    }
    if (this.formModal.codigo.length > 10){
      return this.msgHelper.showToast("O código do cupom só pode ter no máximo 10 caracteres");
    }
    if (this.formModal.valor == 0 || this.formModal.valor == null || this.formModal.valor == ""){
      return this.msgHelper.showToast("Você precisa informar o valor de desconto","bottom",2000);
    }

    this.msgHelper.createLoading('crescent', 'Carregando...');
    this.msgHelper.showLoading();

    this.service.postData(this.formModal, this.urlSearch + "/save", false).then(result => {
      this.msgHelper.closeLoading();
      let response: any = result;
      if (response.result == 0) {
        return this.msgHelper.showAlert("Atenção!", response.message);
      }
      this.msgHelper.showAlert("Sucesso!", response.message);
      document.getElementById(this.targetModal).classList.remove("show");
      this.search();
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

  public search() {
    this.form.page = 1;
    this.getData();
  }

  public backPage() {
    this.form.page = this.form.page - 1;
    this.getData();
  }

  public nextPage() {
    this.form.page = this.form.page + 1;
    this.getData();
  }

  public nextAll() {
    this.form.page = this.resultData.totalPages;
    this.getData();
  }

  public backAll()
  {
    this.search();
  }

  /**
   * Retorna os dados da API
   */
  private getData() {
    this.resultData = null;
    this.service.postData(this.form, this.urlSearch, false).then(result => {
      this.resultData = result;
      console.log(this.resultData);
      if (this.resultData.result == 0) {
        this.resultData = null;
      } else {
        this.resultData = this.resultData.data;
      }
      console.log(this.resultData);
    }, error => {
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

  transformValor(valor : number, withCurrency : boolean = false)
  {
    var numero = valor.toFixed(2).split('.');
    numero[0] =  numero[0].split(/(?=(?:...)*$)/).join('.');
    if (withCurrency){
      return "R$" + numero.join(',');
    }
    return numero.join(',');
  }

  public copyData(obj: any)
  {
    var input = document.createElement('textarea');
    input.innerHTML = obj.codigo;
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand('copy');
    document.body.removeChild(input);
    return this.msgHelper.showToast("Código copiado com sucesso","bottom",1500);
  }

}



// WEBPACK FOOTER //
// ./src/pages/cupons/cupons.ts